/**
 * @generated SignedSource<<4a15b0db8b430fd2e4e4ec348d4bb31b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MondayCreateNewExternalTicketPaneMutation$variables = {
  blockKey: string;
  destinationInfo: any;
  noteId: string;
  title: string;
};
export type MondayCreateNewExternalTicketPaneMutation$data = {
  readonly sendActionItemToIntegration: {
    readonly clientMutationId: string | null;
  } | null;
};
export type MondayCreateNewExternalTicketPaneMutation = {
  response: MondayCreateNewExternalTicketPaneMutation$data;
  variables: MondayCreateNewExternalTicketPaneMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "blockKey"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "destinationInfo"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "noteId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "title"
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "blockKey",
            "variableName": "blockKey"
          },
          {
            "kind": "Variable",
            "name": "destinationInfo",
            "variableName": "destinationInfo"
          },
          {
            "kind": "Literal",
            "name": "integrationProvider",
            "value": "MONDAY"
          },
          {
            "kind": "Variable",
            "name": "noteId",
            "variableName": "noteId"
          },
          {
            "kind": "Variable",
            "name": "title",
            "variableName": "title"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "SendActionItemToIntegrationPayload",
    "kind": "LinkedField",
    "name": "sendActionItemToIntegration",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "MondayCreateNewExternalTicketPaneMutation",
    "selections": (v4/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "MondayCreateNewExternalTicketPaneMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "3b549f7519fae4d807edd878e5a2ad35",
    "id": null,
    "metadata": {},
    "name": "MondayCreateNewExternalTicketPaneMutation",
    "operationKind": "mutation",
    "text": "mutation MondayCreateNewExternalTicketPaneMutation(\n  $blockKey: String!\n  $noteId: ID!\n  $title: String!\n  $destinationInfo: JSON!\n) {\n  sendActionItemToIntegration(input: {blockKey: $blockKey, noteId: $noteId, title: $title, destinationInfo: $destinationInfo, integrationProvider: MONDAY}) {\n    clientMutationId\n  }\n}\n"
  }
};
})();

(node as any).hash = "f16c7d15abec1545ddcd592e473a026d";

export default node;
